import axios from "axios";
import { GridColDef,GridRenderCellParams } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import moment from 'moment';
import "i18n/config";
import i18next from "i18next";
import EditTextarea from 'components/EditableGrid/EditTextarea';

export async function get(assessment_id: string) {

    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/treatment/assessment/"+assessment_id+"/1");
    return response.data;
}

export const update = async (row:any, assessment_id: string) => {
    let response = null;
    if(!row.id) {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/assessment/"+assessment_id+"/store",row);
    } else {
        response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/update/"+row.id,row);
    }
    return response.data;
};

export const destroy = async (id:any) => {
    let response = null;
    response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/treatment/delete/"+id);
    return response.data;
};

export async function getIncrements(assessment_id: string, quarter?: string) {
  if(!quarter) quarter="";
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/treatment/assessment/"+assessment_id+"/increments/"+quarter);
  return response.data;
}

export type WhatIfResult = {
  from: string;
  to: string;
  budget: number;
  treatments: number;
  controls: number;
  target: { coverage: string | null; maturity: string | null };
  risk: { before: number; after: number; delta: number };
  coverage: { before: number; after: number; delta: number };
  maturity: { before: number; after: number; delta: number };
};

export async function getWhatIf(assessment_id: string, from: string, to: string): Promise<WhatIfResult> {
  let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/treatment/assessment/"+assessment_id+"/what-if", {
    params: { from, to }
  });
  return response.data;
}

export async function getColumns(locale: string, setGroupFilter: any) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID', 
      width: 10 
    },
    {
      field: 'category',
      headerName: i18next.t('Category'),
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      minWidth: 250,
      editable: true,
    },
    {
      field: 'start',
      headerName: i18next.t('Start'),
      type: 'date',
      valueGetter: params => moment(params.row.start).toDate(),
      //valueFormatter: params => "Q"+Math.ceil(Number(moment(params?.value).format('M'))/3)+"-"+moment(params?.value).format('YYYY'),
      valueFormatter: params => moment(params?.value).format('D/MM/YYYY'),
      flex: 1,
      maxWidth: 250,
      minWidth: 80,
      editable: true,
    },
    {
      field: 'end',
      headerName: i18next.t('End'),
      type: 'date',
      valueGetter: params => moment(params.row.end).toDate(),
      //valueFormatter: params => "Q"+Math.ceil(Number(moment(params?.value).format('M'))/3)+"-"+moment(params?.value).format('YYYY'),
      valueFormatter: params => moment(params?.value).format('D/MM/YYYY'),
      flex: 1,
      maxWidth: 250,
      minWidth: 80,
      editable: true,
    },
    {
      field: 'owner',
      headerName: i18next.t('Owner'),
      flex: 1,
      minWidth: 150,
      editable: true,
    },
    {
      field: 'budget',
      headerName: i18next.t('Budget'),
      flex: 1,
      minWidth: 60,
      maxWidth: 80,
      editable: true,
      valueFormatter: params => params?.value + 'K',
      align: 'right'
    },
      {
        field: 'status',
        headerName: i18next.t('Status'),
        flex: 1,
        editable: true,
        type: 'singleSelect',
        minWidth: 100,
        valueOptions: [],
        valueGetter: params => params.row.status || '',
      }
  ] as GridColDef[];
}



